import styled from 'styled-components';

export const LoaderStyled = styled.div`
  height: 100vh;
  width: 100%;
  opacity: 1;
  background: ${(props) => props.theme.color.black}33;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000000;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  animation: fade 0.4s ease-in forwards;

  &.darkOverlay {
    background: ${(props) => props.theme.color.black}80;
  }

  .loaderBox {
    width: 100px;
    height: 100px;
    background: ${(props) => props.theme.color.white};
    border-radius: 10px;
    box-shadow: 0 4px 25px 0 ${(props) => props.theme.color.black}1A;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &.withoutBG {
      width: auto;
      min-width: 100px;
      min-height: 100px;
      background: transparent;
      box-shadow: 0 0 0;
    }

    .aster_logo {
      width: 65px;
      height: 35px;
      margin: 0 0 20px 0;
      position: relative;
      display: flex;
      justify-content: center;

      img {
        width: 46px;
        height: 46px;
      }
    }
  }

  .threeDots {
    width: 100%;
    display: flex;
    justify-content: center;

    .loaderDots {
      width: 10px;
      height: 10px;
      background-image: linear-gradient(180deg, #00ce57 0%, #0076b5 100%);
      margin: 0 3px;
      position: relative;
      display: inline-block;
      border-radius: 50%;
      transform: translateZ(0);
      animation: loaderAnimation 1s infinite ease-in-out;

      &.dot1 {
        animation-delay: 0.2s;
      }

      &.dot2 {
        animation-delay: 0.4s;
      }

      &.dot3 {
        animation-delay: 0.6s;
      }
    }

    &.bigDots {
      .loaderDots {
        width: 30px;
        height: 30px;
      }
    }
  }

  @keyframes loaderAnimation {
    0%,
    80%,
    100% {
      transform: scale(0.4);
    }

    40% {
      transform: scale(1);
    }
  }
`;

export const InnerLoaderContainerStyled = styled.div`
  position: relative;
  .fadeIn {
    visibility: visible;
    opacity: 1;
    transition-delay: 0ms;
  }
  .fadeOut {
    visibility: hidden;
    opacity: 0;
    transition: opacity 150ms ease-in, visibility 0ms ease-in 250ms;
  }

  .loaderWithLogo {
    background: ${(props) => props.theme.color.black}40;
  }

  .loaderWithoutLogo {
    background: ${(props) => props.theme.green.extraLight}80;
    z-index: 1; 
  }
  .bluredBG {
    filter: blur(3px);
  }
`;

export const InnerLoaderStyled = styled.div`
  position: absolute;
  animation: fade 0.4s ease-in forwards;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000000;
  flex-direction: column;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  .loaderBoxWithLogo {
    width: 100px;
    height: 100px;
    background: ${(props) => props.theme.color.white};
    border-radius: 10px;
    box-shadow: 0 4px 25px 0 ${(props) => props.theme.color.black}1A;
  }

  .loaderBox {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .aster_logo {
      width: 65px;
      height: 35px;
      margin: 0 0 10px 0;
      position: relative;
      display: flex;
      justify-content: center;

      img {
        width: 46px;
        height: 46px;
      }
    }
  }

  .threeDots {
    width: 100%;
    display: flex;
    justify-content: center;

    .loaderDots {
      display: inline-block;
      width: 10px;
      height: 10px;
      margin: 0 3px;
      background-image: linear-gradient(180deg, #00ce57 0%, #0076b5 100%);
      position: relative;
      transform: translateZ(0);
      animation: loaderAnimation 1s infinite ease-in-out;
      border-radius: 50%;

      &.dot1 {
        animation-delay: 0.2s;
      }

      &.dot2 {
        animation-delay: 0.4s;
      }

      &.dot3 {
        animation-delay: 0.6s;
      }
    }
  }

  @keyframes loaderAnimation {
    0%,
    80%,
    100% {
      transform: scale(0.4);
    }

    40% {
      transform: scale(1);
    }
  }
`;
